<template>
  <div class="stages-planner-customers">

    <!-- Customers list -->
    <div
      v-for="(customer, index) in customers"
      :key="`customer-index-${index}`"
      class="mb-4"
    >
      <div class="columns">
        <div class="column">
          <b-field label-position="on-border" label="Nom de famille">
            <b-input v-model="customer.lastname" />
          </b-field>
        </div>
        <div class="column">
          <b-field label-position="on-border" label="Prénom">
            <b-input v-model="customer.firstname" />
          </b-field>
        </div>
        <div class="column is-two-fifths">
          <date-of-birth v-model="customer.date_of_birth" />
        </div>
      </div>
    </div>

    <!-- Add new customer -->
    <div class="text-right mt-4">
      <b-button
        class="mr-2"
        @click="removeChild"
        type="light"
        icon-right="minus"
        rounded
        :disabled="customers.length <= 1"
      />
      <b-button
        @click="addChild"
        rounded
        icon-left="plus"
      >
        Ajouter
      </b-button>
    </div>
  </div>
</template>

<script>
import DateOfBirth from "@/components/ui/DateOfBirth";

export default {
  name: 'CustomerStageFrom',
  props: ["value"],
  components: { DateOfBirth },

  data () {
    return {
      customers: [
        {
          firstname: null,
          lastname: null,
          date_of_birth: null
        }
      ]
    }
  },

  watch: {
    customers: {
      handler: function (value) {
        this.$emit("input", value);
        },
      deep: true
    }
  },

  methods: {
    addChild () {
      this.customers.push({
        firstname: null,
        lastname: null,
        date_of_birth: null
      })
    },

    removeChild () {
      if (this.customers.length === 1) { return; }

      this.customers.pop();
    }
  },
}
</script>
